module.exports = __webpack_public_path__ + "static/media/loader-small.9c2053cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader-small.svg
// module id = 81
// module chunks = 0